import type { ThemePreset } from "../types";

export const forest: ThemePreset = {
  id: "forest",
  name: "Wald",
  nameKey: "admin.settings.appearance.themes.forest.name",
  description: "Natürliche Grüntöne",
  descriptionKey: "admin.settings.appearance.themes.forest.description",
  light: {
    background: "oklch(0.985 0.005 145)",
    foreground: "oklch(0.15 0.02 150)",
    card: "oklch(1 0 0)",
    "card-foreground": "oklch(0.15 0.02 150)",
    popover: "oklch(1 0 0)",
    "popover-foreground": "oklch(0.15 0.02 150)",
    primary: "oklch(0.50 0.15 145)",
    "primary-foreground": "oklch(0.985 0 0)",
    secondary: "oklch(0.95 0.02 145)",
    "secondary-foreground": "oklch(0.20 0.02 150)",
    muted: "oklch(0.95 0.015 145)",
    "muted-foreground": "oklch(0.50 0.02 150)",
    accent: "oklch(0.92 0.03 140)",
    "accent-foreground": "oklch(0.20 0.02 150)",
    destructive: "oklch(0.577 0.245 27.325)",
    "destructive-foreground": "oklch(0.985 0 0)",
    border: "oklch(0.90 0.02 145)",
    input: "oklch(0.90 0.02 145)",
    ring: "oklch(0.50 0.15 145)",
    "sidebar-background": "oklch(0.98 0.008 145)",
    "sidebar-foreground": "oklch(0.30 0.02 150)",
    "sidebar-primary": "oklch(0.50 0.15 145)",
    "sidebar-primary-foreground": "oklch(0.985 0 0)",
    "sidebar-accent": "oklch(0.93 0.025 140)",
    "sidebar-accent-foreground": "oklch(0.20 0.02 150)",
    "sidebar-border": "oklch(0.90 0.02 145)",
    "sidebar-ring": "oklch(0.50 0.15 145)",
  },
  dark: {
    background: "oklch(0.17 0.02 150)",
    foreground: "oklch(0.92 0.01 145)",
    card: "oklch(0.20 0.02 150)",
    "card-foreground": "oklch(0.92 0.01 145)",
    popover: "oklch(0.20 0.02 150)",
    "popover-foreground": "oklch(0.92 0.01 145)",
    primary: "oklch(0.65 0.13 145)",
    "primary-foreground": "oklch(0.15 0.02 150)",
    secondary: "oklch(0.25 0.02 150)",
    "secondary-foreground": "oklch(0.90 0.01 145)",
    muted: "oklch(0.25 0.02 150)",
    "muted-foreground": "oklch(0.65 0.02 145)",
    accent: "oklch(0.28 0.025 145)",
    "accent-foreground": "oklch(0.92 0.01 145)",
    destructive: "oklch(0.55 0.22 27)",
    "destructive-foreground": "oklch(0.98 0 0)",
    border: "oklch(0.30 0.02 150)",
    input: "oklch(0.30 0.02 150)",
    ring: "oklch(0.65 0.13 145)",
    "sidebar-background": "oklch(0.14 0.02 150)",
    "sidebar-foreground": "oklch(0.82 0.015 145)",
    "sidebar-primary": "oklch(0.65 0.13 145)",
    "sidebar-primary-foreground": "oklch(0.15 0.02 150)",
    "sidebar-accent": "oklch(0.22 0.02 150)",
    "sidebar-accent-foreground": "oklch(0.92 0.01 145)",
    "sidebar-border": "oklch(0.28 0.02 150)",
    "sidebar-ring": "oklch(0.65 0.13 145)",
  },
};
